import React from "react";
import { useNavigate } from "react-router-dom";

import { usePageDetails } from "../../hooks/usePageDetails";
import CustomButton from "../CustomButton/CustomButton";
import "./form-action-buttons.scss";

type FormActionButtonsProps = {
  isSubmitting?: boolean;
  disable?: boolean;
  navigateUrl?: string;
  onClick?: any;
  labelFirstButton?: string;
  labelSecondButton?: string;
};

const FormActionButtons = ({
  isSubmitting = false,
  disable = false,
  navigateUrl = "/",
  onClick,
  labelFirstButton,
  labelSecondButton = "Add",
}: FormActionButtonsProps) => {
  const navigate = useNavigate();
  const { pageType } = usePageDetails();
  const secondButtonLabel =
    pageType === "create" ? labelSecondButton : "Update";

  return (
    <div className="buttons-position-fixed" style={{ width: "100%" }}>
      <CustomButton
        isSubmitting={false}
        label={labelFirstButton ?? "Cancel"}
        customClass={`w-11rem px-1 py-0 m-0 h-48 fs-6 ${pageType === "view" ? "me-3" : ""}`}
        onClick={() => navigate(navigateUrl)}
      />
      {pageType !== "view" && (
        <CustomButton
          isSubmitting={isSubmitting}
          label={secondButtonLabel}
          customClass="w-11rem px-1 py-0 m-0 h-48 fs-6 me-3"
          type="submit"
          disabled={disable}
          onClick={onClick}
        />
      )}
    </div>
  );
};

export default FormActionButtons;
